import {
  TractorIcon,
  TreesIcon,
  LayersIcon,
  WheatIcon,
  SproutIcon,
  ScissorsIcon,
  LeafIcon,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const homeHero = {
  eyebrow: 'Proudly Serving the Augusta, GA Area',
  headline: 'Your Local Lawncare Experts',
  supporting: 'Lawn Maintenance, Landscaping, Mulch, Pine Straw, Sod Installation, and More.',
  background: 'https://cdn.magicpatterns.com/patterns/generated-images/b720c695-8762-4acd-893c-29ab0b58d2ab.jpg',
  backgroundAlt: 'Beautiful home with a striped green lawn, trimmed bushes, flower beds, and mature trees',
  mascotImage: 'https://cdn.magicpatterns.com/uploads/pbRXkqpcnSoMKjiWUavDy6/Friendly_Lawn_Care_Mascot_Logo.png',
  mascotAlt: 'Chacon’s Lawncare mascot waving hello',
};

export const homeChristmasPromo = {
  href: '/christmas-lights',
  heading: 'Christmas Lights',
  supporting: 'Design • Installation • Maintenance • Removal',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e9dbe8d8-a897-4cad-b9dc-631ab1b26d26.jpg',
  imageAlt: 'Home at night decorated with warm white roofline Christmas lights, wreaths, and lit trees',
};

export const homeServices: { label: string; icon: LucideIcon }[] = [
  { label: 'Lawn Maintenance', icon: TractorIcon },
  { label: 'Landscaping', icon: TreesIcon },
  { label: 'Mulch Installation', icon: LayersIcon },
  { label: 'Pine Straw', icon: WheatIcon },
  { label: 'Sod Installation', icon: SproutIcon },
  { label: 'Bush Trimming', icon: ScissorsIcon },
  { label: 'Leaf Cleanup', icon: LeafIcon },
];
